module.exports = "<symbol id=\"tt-icon-star--empty\" viewBox=\"0 0 24 24\"><path d=\"M12 18l-6.4 3.88 1.73-7.33-5.66-4.93L9.09 9 12 2.09 14.91 9l7.42.64-5.63 5 1.72 7.34z\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/non-defined-page/star--empty.svg
// module id = 193
// module chunks = 11